import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel';
import { useBPCChartsDataContext } from './hooks/useBPCChartsDataContext';

export const PaymentsMonthSum = () => {
    const { chartData } = useBPCChartsDataContext();

    const rawData = chartData?.paymentsMonth || [];

    const isYearComparison =
        rawData.length > 0 &&
        rawData.every(item => item.mes === rawData[0].mes);

    const subtitles = isYearComparison
        ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`)
        : rawData.map(item => getMonthLabel(item.mes));

    const series = [
        {
            name: 'Valor Médio',
            data: rawData.map(item => item.sum_value)
        }
    ];

    return (
        <SimpleBars
            title="Valor Total - Mensal"
            horizontal={false}
            subtitles={subtitles}
            series={series}
            showDataLabels={false}
        />
    );
};
